<template>
  <el-table v-loading="loading" :data="dataList" :height="height">
    <el-table-column v-if="!Boolean(contractId)" label="合同名称" min-width="100" align="center">
      <template slot-scope="scope">
        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail(scope.row)">{{scope.row.contractName}}</el-link>
      </template>
    </el-table-column>
    <el-table-column label="发票号码" min-width="190" align="center" prop="invoiceNum" show-overflow-tooltip />
    <el-table-column label="发票抬头" min-width="150" align="center">
      <template slot-scope="scope">
        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.invoiceTitle}}</el-link>
      </template>
    </el-table-column>
    <el-table-column label="发票类型" width="100" align="center" prop="invoiceTypeDesc" />
    <el-table-column label="开票金额(元)" width="150" align="center">
      <template slot-scope="scope">
        <span>{{ amountFormat(scope.row.invoiceAmount) }}</span>
      </template>
    </el-table-column>
    <el-table-column label="开票时间" width="100" align="center" prop="invoiceDate" />
    <el-table-column label="操作" width="90" align="center" fixed="right" class-name="small-padding fixed-width">
      <template slot-scope="scope">
        <el-button type="text" icon="el-icon-edit" @click="toEdit(scope.row)">编辑</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>

import {listContractInvoice} from "@/api/crm/invoice";
import { amountFormat } from '@/utils/index'

export default {
  name: "InvoiceList",
  props: {
    customerId: {},
    contractId: {},
    height: {
      type: String,
      default () {
        return "250"
      }
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      amountFormat
    };
  },
  created() {
    if (this.customerId || this.contractId) {
      this.queryList();
    }
  },
  components: {
  },
  watch: {
    customerId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    },
    contractId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    }
  },
  methods: {
    queryList () {
      this.loading = true;
      listContractInvoice(
        {
          customerId: this.customerId,
          contractId: this.contractId
        }
      ).then(response => {
          this.dataList = response.data || [];
          this.$emit('after-query', this.dataList);
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 详细按钮操作 */
    toContractDetail(row) {
      window.open("/crm/contract/detail/" + row.contractId, "_blank")
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/invoice/detail/" + row.id, "_blank")
    },
    /** 编辑按钮操作 */
    toEdit(row) {
      window.open("/crm/invoice/detail/" + row.id + "?edit=1", "_blank")
    },
  }
};
</script>
